/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyTemperatureSensorSerializer
 */
export interface WriteOnlyTemperatureSensorSerializer {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    sensorName: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    sensorType?: WriteOnlyTemperatureSensorSerializerSensorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    sensorZone?: number;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyTemperatureSensorSerializer
     */
    monitoredObject: number;
}

export function WriteOnlyTemperatureSensorSerializerFromJSON(json: any): WriteOnlyTemperatureSensorSerializer {
    return WriteOnlyTemperatureSensorSerializerFromJSONTyped(json, false);
}

export function WriteOnlyTemperatureSensorSerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyTemperatureSensorSerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'serialNumber': json['serial_number'],
        'sensorName': json['sensor_name'],
        'sensorType': !exists(json, 'sensor_type') ? undefined : json['sensor_type'],
        'sensorZone': !exists(json, 'sensor_zone') ? undefined : json['sensor_zone'],
        'monitoredObject': json['monitored_object'],
    };
}

export function WriteOnlyTemperatureSensorSerializerToJSON(value?: WriteOnlyTemperatureSensorSerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'serial_number': value.serialNumber,
        'sensor_name': value.sensorName,
        'sensor_type': value.sensorType,
        'sensor_zone': value.sensorZone,
        'monitored_object': value.monitoredObject,
    };
}

/**
* @export
* @enum {string}
*/
export enum WriteOnlyTemperatureSensorSerializerSensorTypeEnum {
    TemperatureSensor = 'temperature_sensor'
}


